import React, { Component } from 'react';
import { Row, Col, Table, Button, Input, Popconfirm, message, Checkbox, Switch } from 'antd';
import Title from 'antd/lib/typography/Title';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification, NetworkDelaySearch, formatMoney } from '../../../lib/util';

const all_data_cols = ({ onAssignData }) => [
  {
    title: "Name",
    dataIndex: "name",
    key: 'name'
  }, {
    title: "",
    dataIndex: "id",
    key: 'id',
    width: 20,
    render: (id) => {
      return <span>
        <Button
          type='link'
          style={{ padding: 0 }}
          onClick={() => {
            typeof onAssignData === 'function' && onAssignData(id)
          }}>Assign</Button>
      </span>
    }
  }
]
const user_data_cols = ({ onRemoveData,onToggleAccess }) => [
  {
    title: "Name",
    dataIndex: "name",
    key: 'name'
  }, 
  {
    title: "Write Access",
    dataIndex: "write_flag",
    key: 'write_flag',
    render:(access,data)=>{
      return <Switch checked={access} onChange={(checked)=>{
        typeof onToggleAccess==='function'&&onToggleAccess(data.id,checked)
      }} />
    }
  }, 
  {
    title: "",
    dataIndex: "id",
    key: 'id',
    width: 20,
    render: (id) => {
      return <span>
        <Popconfirm title="Are you sure you want to remove this repository for user?"
          onConfirm={() => {
            typeof onRemoveData === 'function' && onRemoveData(id)
          }}>
          <Button
            type='link'
            style={{
              color: 'red',
              padding: 0
            }}
          >Remove</Button>
        </Popconfirm>
      </span>
    }
  }
]

class RepositoryAssigner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      all_filter: {
        per_page: 100,
        page: 1
      },

      assigned_filter: {
        per_page: 100,
        page: 1
      }
    };

    this.list_assigned = RESTExecutor.list().config({
      label: 'assigned_repository',
      params: {
        ...this.state.assigned_filter
      }
    }).callbacks((success) => {
    }, (error) => {

    }).forId(this.props.user_id).connect(props.domains.users);

    this.list_unassigned = RESTExecutor.list().config({
      label: 'unassigned_repository',
      params: {
        ...this.state.all_filter
      }
    }).callbacks((success) => {
    }, (error) => {
    }).forId(this.props.user_id).connect(props.domains.users);

    this.assign_data = RESTExecutor.post().config({
      label: 'assigned_repository'
    }).callbacks((success) => {
      this.list_assigned.execute();
      this.stateUpdater({
        stateKey: 'all_filter',
        appendObj: {
          page: 1
        },
        callback: () => {
          this.list_unassigned.config({
            params: {
              ...this.state.all_filter
            }
          }).execute();
        }
      });

      message.success("Repository assigned");
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.modify_data=RESTExecutor.patch().config({
      label: 'assigned_repository_detail',
      
    }).callbacks((success) => {
      this.list_assigned.execute();
      this.stateUpdater({
        stateKey: 'all_filter',
        appendObj: {
          page: 1
        },
        callback: () => {
          // this.list_unassigned.config({
          //   params: {
          //     ...this.state.all_filter
          //   }
          // }).execute();
        }
      });

      message.success("Repository modified");
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.remove_data = RESTExecutor.delete().config({
      label: 'assigned_repository_detail'
    }).callbacks((success) => {
      this.stateUpdater({
        stateKey: 'assigned_filter',
        appendObj: {
          page: 1
        },
        callback: () => {
          this.list_assigned.config({
            params: {
              ...this.state.assigned_filter
            }
          }).execute();
        }
      });
      // this.list_assigned.execute();
      this.list_unassigned.execute();
      message.success("Repository removed");
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.users);

    this.delay_1=new NetworkDelaySearch();
    this.delay_2=new NetworkDelaySearch();

    this.list_assigned.execute();
    this.list_unassigned.execute();
  };

  assignData = (id) => {
    this.assign_data.forId(this.props.user_id).execute({
      repository_id: id
    });
  }

  removeData = (id) => {
    // console.log("remove",id)
    this.remove_data.config({
      params: {
        user_id: this.props.user_id,
        data_id: id
      }
    }).execute()
  }

  stateUpdater = ({
    stateKey,
    removeKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    if (removeKey) {
      delete newData[removeKey]
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {
    const { all_filter, assigned_filter } = this.state;

    let list_assigned_resp = this.list_assigned.response();
    let list_unassigned_resp = this.list_unassigned.response();

    let list_assigned_rows = (list_assigned_resp.result && list_assigned_resp.result.rows) || [];
    let list_unassigned_rows = (list_unassigned_resp.result && list_unassigned_resp.result.rows) || [];

    let list_assigned_meta = list_assigned_resp.meta || {};
    let list_unassigned_meta = list_unassigned_resp.meta || {};


    return (
      <Row
        type='flex'
        justify='space-around'
        style={{
          flexWrap: 'nowrap'
        }}>
        <Col span={11}>
          <center>
            <Title level={3} type='secondary'>All Repositories</Title>
          </center>
          <Row
            type='flex'
            style={{
              flexWrap: 'nowrap',
              alignItems: 'center',
              paddingBottom: 6
            }}>
            <Input.Search
              value={all_filter.query}
              placeholder="Search For"
              onChange={(e) => {
                this.stateUpdater({ stateKey: 'all_filter', valueKey: 'query', value: e.target.value,callback:()=>{
                  this.delay_1.onSearch(()=>{
                    this.list_unassigned.config({
                      params: {
                        ...all_filter,
                        page:1
                      }
                    }).execute();
                  })
                } })
              }}
            ></Input.Search>
            {/* <Button
              onClick={() => {
                this.stateUpdater({
                  stateKey: 'all_filter',
                  removeKey: 'query',
                  appendObj: {
                    page: 1
                  },
                  callback: () => {
                    console.log("callback");
                    this.list_unassigned.config({
                      params: {
                        ...all_filter
                      }
                    }).execute();
                  }
                })
              }}
              type='link'
              style={{
                color: 'red',
                paddingRight: 0
              }}>Clear</Button>
          */}
          </Row>
          <Table
          scroll={{x:true}}
            loading={list_unassigned_resp.fetching}
            pagination={{
              position: 'bottom',
              onChange: (page_no, pageSize) => {
                this.stateUpdater({
                  stateKey: 'all_filter',
                  appendObj: {
                    page: page_no,
                    per_page: pageSize
                  },
                  callback: () => {
                    this.list_unassigned.config({
                      params: {
                        ...all_filter
                      }
                    }).execute()
                  }
                })
              },
              defaultCurrent: 1,
              current: list_unassigned_meta.pagination && parseInt(list_unassigned_meta.pagination.split('/')[0]),
              // defaultPageSize: 20,
              pageSize: (list_unassigned_meta && list_unassigned_meta.requested_count),

              total: (list_unassigned_meta && list_unassigned_meta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`

            }}
            rowClassName='custom-padding'
            style={{ "--paddingval": 2 }}
            dataSource={list_unassigned_rows}
            size='small' columns={all_data_cols({ onAssignData: this.assignData })} />

        </Col>
        <Col span={11}>
          <center>
            <Title level={3} type='secondary'>Assigned Repositories</Title>
          </center>
          <Row
            type='flex'
            style={{
              flexWrap: 'nowrap',
              alignItems: 'center',
              paddingBottom: 6
            }}>
            <Input.Search
              value={assigned_filter.query}
              placeholder="Search For"
              onChange={(e) => {
                this.stateUpdater({ stateKey: 'assigned_filter', valueKey: 'query', value: e.target.value,callback:()=>{
                  this.delay_2.onSearch(()=>{
                    this.list_assigned.config({
                      params: {
                        ...assigned_filter,
                        page:1
                      }
                    }).execute();
                  })
                } })
              }}
              // onSearch={(value) => {
              //   this.list_assigned.config({
              //     params: {
              //       ...assigned_filter
              //     }
              //   }).execute();
              // }}
            ></Input.Search>
            {/* <Button
              onClick={() => {
                this.stateUpdater({
                  stateKey: 'assigned_filter',
                  removeKey: 'query',
                  appendObj: {
                    page: 1
                  },
                  callback: () => {
                    this.list_assigned.config({
                      params: {
                        ...assigned_filter
                      }
                    }).execute();
                    console.log("callback");
                  }
                })
              }}
              type='link'
              style={{
                color: 'red',
                paddingRight: 0
              }}>Clear</Button>
         */}
          </Row>
          <Table
          scroll={{x:true}}
            loading={list_assigned_resp.fetching}
            pagination={{
              position: 'bottom',
              onChange: (page_no, pageSize) => {
                this.stateUpdater({
                  stateKey: 'assigned_filter',
                  appendObj: {
                    page: page_no,
                    per_page: pageSize
                  },
                  callback: () => {
                    this.list_assigned.config({
                      params: {
                        ...assigned_filter
                      }
                    }).execute()
                  }
                })
              },
              defaultCurrent: 1,
              current: list_assigned_meta.pagination && parseInt(list_assigned_meta.pagination.split('/')[0]),
              // defaultPageSize: 20,
              pageSize: (list_assigned_meta && list_assigned_meta.requested_count),

              total: (list_assigned_meta && list_assigned_meta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`

            }}
            dataSource={list_assigned_rows}
            size='small' columns={user_data_cols({ 
              onRemoveData: this.removeData ,
              onToggleAccess:(id,checked)=>{
                this.modify_data.config({
                  params: {
                    user_id: this.props.user_id,
                    data_id: id
                  }
                }).execute({write_flag:checked})
              }
              })} />
        </Col>

      </Row>
    );
  }
}

export default withDomains(RepositoryAssigner, "users");
